export default __webpack_public_path__ + "static/media/IF_MyStrengths_Small.5ac834f4.jpg";